import { sendEventToAnalytics } from '@lib/helpers/client'

export default function profileDeleteAccountEvent(reason: string): void {
  const eventName = 'web_delete_account'
  const payload = { reason }
  sendEventToAnalytics(eventName, payload)
}
